import { Box } from '@indoqa/style-system';
import * as React from 'react';
import { withUIETheme } from '../uietheme/withUIETheme';
import { scrollbarStyles } from './scrollbarStyles';
const Menu = ({ children, uieTheme }) => {
    const style = {
        boxSizing: 'border-box',
        backgroundColor: uieTheme.colors.bgMenu,
        ...scrollbarStyles(uieTheme),
        tablet: {
            overflowY: 'auto',
            borderBottom: 'none',
        },
    };
    return (React.createElement(Box, { fullWidth: true, fullHeight: true, style: style }, children));
};
export default withUIETheme(Menu);
//# sourceMappingURL=Menu.js.map